import { render, staticRenderFns } from "./email-distributions-create.vue?vue&type=template&id=0e6cc838"
import script from "./email-distributions-create.vue?vue&type=script&lang=js"
export * from "./email-distributions-create.vue?vue&type=script&lang=js"
import style0 from "./email-distributions-create.vue?vue&type=style&index=0&id=0e6cc838&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports